/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function(window, $) {

  //TODO - Replace and add a section in the admin panel for user to input these
  const navLearnMore = [
    {
      id: "/collections/incontinence",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/incontience_430x.jpg?v=1729621182",
      copy: "Explore resources designed to help you find the best incontinence solutions for your unique needs.",
      cta_label: "Incontinence",
      cta_link: "/pages/incontinence-1"
    },
    {
      id: "/collections/ostomy",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/ostomy_430x.jpg?v=1729621182",
      copy: "Browse a variety of resources that can help you manage your unique ostomy needs.",
      cta_label: "Ostomy",
      cta_link: "/pages/ostomy"
    },
    {
      id: "/collections/cpap",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/cpap_430x.jpg?v=1729621182",
      copy: "Discover our wide range of sleep apnea resources and learn what you can do to get a better night's sleep.",
      cta_label: "CPAP",
      cta_link: "/pages/cpap"
    },
    {
      id: "/collections/electronics-1",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/electronics_430x.jpg?v=1729621182",
      copy: "Gain a better understanding of our latest electronics products and solutions with these helpful resources.",
      cta_label: "Electronics",
      cta_link: "/pages/electronics"
    },
    {
      id: "/collections/sleep-aids",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/sleepaids_430x.jpg?v=1729621182",
      copy: "Explore resources designed to help you find the best sleep solutions for your unique needs.",
      cta_label: "Sleep Aids",
      cta_link: "/pages/sleep-aids"
    },
    {
      id: "/collections/light-therapy",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/lighttherapy_430x.jpg?v=1729621182",
      copy: "Gain a better understanding of our latest light therapy products and solutions with these helpful resources.",
      cta_label: "Light Therapy",
      cta_link: "/pages/light-therapy"
    },
    {
      id: "/collections/rollators-walkers",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/rollatorwalkers_430x.jpg?v=1729621182",
      copy: "Discover our wide range of mobility resources and learn what you can do to help maintain your independence.",
      cta_label: "Rollators & Walkers",
      cta_link: "/pages/rollators-walkers"
    },
    {
      id: "/collections/scooters-power-chairs-1",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/scooterspowerchairs_430x.jpg?v=1729621182",
      copy: "Gain a better understanding of our scooters and power chairs with these helpful resources.",
      cta_label: "Scooters & Power Chairs",
      cta_link: "/pages/scooters-power-chairs"
    },
    {
      id: "/collections/wheelchairs-transport-chairs",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/wheelchairs_430x.jpg?v=1729621182",
      copy: "Browse a variety of resources that can help you manage your unique mobility needs.",
      cta_label: "Wheelchairs & Transport Chairs",
      cta_link: "/pages/wheelchairs-transport-chairs"
    },
    {
      id: "/collections/canes-1",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/canes_430x.jpg?v=1729621182",
      copy: "Explore resources designed to help you find the best cane(s) for your unique needs.",
      cta_label: "Canes",
      cta_link: "/pages/canes"
    },
    {
      id: "/collections/braces-supports",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/bracessupport_430x.jpg?v=1729621182",
      copy: "Gain a better understanding of our latest braces and supports offerings with these helpful resources.",
      cta_label: "Braces & Supports",
      cta_link: "/pages/braces-supports"
    },
    {
      id: "/collections/compression",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/compression_430x.jpg?v=1729621182",
      copy: "Discover our wide range of compression therapy resources and how compression products could help you.",
      cta_label: "Compression",
      cta_link: "/pages/compression"
    },
    {
      id: "/collections/pain-management",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/painmanagement_430x.jpg?v=1729621182",
      copy: "Explore resources designed to help you learn more about available pain management products and solutions.",
      cta_label: "Pain Management",
      cta_link: "/pages/pain-management"
    },
    {
      id: "/collections/health-monitoring",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/healthmonitoring_430x.jpg?v=1729621182",
      copy: "Browse a variety of resources that can help you better understand your health monitoring needs.",
      cta_label: "Health Monitoring",
      cta_link: "/pages/health-monitoring"
    },
    {
      id: "/collections/home-1",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/home_430x.jpg?v=1729621183",
      copy: "Discover our wide range of home comfort and safety resources and learn what you can do to stay longer in the home you love.",
      cta_label: "Home",
      cta_link: "/pages/home"
    },
    {
      id: "/collections/daily-living",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/dailyliving_430x.jpg?v=1729621182",
      copy: "Gain a better understanding of our latest daily living products and solutions with these helpful resources.",
      cta_label: "Daily Living",
      cta_link: "/pages/daily-living"
    },
    {
      id: "/collections/fitness-nutrition",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/fitness_430x.jpg?v=1729621182",
      copy: "Explore resources designed to help you create and reach your fitness and nutrition goals.",
      cta_label: "Fitness & Nutrition",
      cta_link: "/pages/fitness-nutrition"
    },
    {
      id: "/collections/wellness",
      image_name: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/wellness_430x.jpg?v=1729621182",
      copy: "Browse a variety of wellness resources that can help educate you on your everyday needs.",
      cta_label: "Wellness",
      cta_link: "/pages/wellness"
    }
  ];

  window.matchHeights = function(selector, resizeEnabled, extraHeight) {
    resizeEnabled = resizeEnabled || false;
    extraHeight = extraHeight || 0;
    
    const $sel = $(selector);
    const resizeHeight = function() {
    	var minHeight = 0;
		var heights = $sel.get().map(function(item) {
			return $(item).height();
		});
  	
  		if(heights.length > 0 ) {
      		minHeight = heights.sort(function(a, b) {
        		return b - a;
      		})[0];
      		$sel.css('min-height', minHeight + extraHeight);
  		}
		//console.log(selector, minHeight, resizeEnabled);
    };
    resizeHeight();
    
    $(window).on('resize', function() {
      if(resizeEnabled) {
    	$sel.attr('style', '');
      	resizeHeight();
      }
    });
  };
  window.deeplinkTo = function(hash, delay) {
    hash = hash || window.location.hash;
    delay = delay || 500;
    
    //console.log('dl', hash, delay);
    
    if(hash.indexOf('#deeplink=') > -1) {
      var selector = hash.replace('#deeplink=', '');
      var scrollPosition = $(selector).offset().top - ($('#shopify-section-header').height() + 20);
      
      setTimeout(function() {
          $('html, body').animate({
            scrollTop: scrollPosition
          });
      }, delay);
    }
  };
  
  
  $(document).ready(function() {
    // Arranges the "top" of sub-items in the main menu ------------------ //
    $("#mobile-panel-0").on("scroll",function(){
        $(".mobile-menu__section > .mobile-menu__nav-list .mobile-menu__nav-list-item > .mobile-menu__panel.is-nested").css({top:$(this).scrollTop()});
    });

    $(".mobile-menu__inner > .mobile-menu__panel").on("scroll",function(){
       $(".mobile-menu__nav .mobile-menu__nav-item > .mobile-menu__panel.is-nested").css({top:$(this).scrollTop()});
    });

    // Main Menu - mobile-menu__panel Scroll control ------------------ //
    $(".mobile-menu__primary-button").on("click",function(){
        $(".mobile-menu__inner > .mobile-menu__panel").toggleClass("hidescroll_panel");
        $("#mobile-menu").toggleClass("hidescrolling");
        $("#mobile-menu").scrollTop(0);
    });

    
    // CODE TO IMAGE SLIDER ON PDP ------------------ //
        var links=$(".product-gallery__thumbnail-list .thumbsContainer > a"), photos = [];    
        for (var i = 0; i<links.length; i++){
            photos.push(links[i].href);
        }

        // Checks the number of thumbnails to leave them with the correct spacing
        var thumbs_quant = $("#thumbnailList .thumbsContainer > a").length;
        if(thumbs_quant <= 6){
          $("#thumbnailList").addClass("belowSeven");
        }

    
        //var thumb_width = $("#thumbnailList .thumbsContainer > a").eq(0).outerWidth();
        //var thumb_margin = 12; //The first and last thumb are margin 6
        //var containerThumbs_width = ((thumb_width + thumb_margin) * thumbs_quant - thumb_margin); 
        var thumb_selected = "";
        var thumb_positionSelected = "";
        var thumbs_containerPosition = $(".thumbsContainer").offset();
        var cssContainerLeft = "";
        var cssContainerLeftValue = ""

        // DANIEL FRANCO - TASK 30818
        $('.product-gallery__thumbnail').on('click', function() {
          var center = document.querySelector("#thumbnailList").offsetLeft + document.querySelector("#thumbnailList").offsetWidth / 2;
          var scrollToPosition = this.offsetLeft < center ? 0 : center - (this.offsetLeft + (this.offsetWidth * 2));
          $('.thumbsContainer').css('left', scrollToPosition);
                
        });
        
        $('.arrow__right').on('click', function() {
          
            // Mark current thumb
            var count = $("#thumbnailList .thumbsContainer > a.product-gallery__thumbnail.is-nav-selected").index();
            count++;
            if(count >= photos.length){
                count = 0;
                $(".product-gallery__image").attr("srcset",photos[count]);
                $(".product-gallery__image").attr("data-zoom",photos[count]);
            }else{
                $(".product-gallery__image").attr("srcset",photos[count]);
                $(".product-gallery__image").attr("data-zoom",photos[count]);
            } 
        
            $("#thumbnailList .thumbsContainer > a").removeClass("is-nav-selected")
            $("#thumbnailList .thumbsContainer > a").eq(count).addClass("is-nav-selected");
    

            if(thumbs_quant > 6){
                      
              // Advanced group of thumbnails
              thumb_selected = $("#thumbnailList .thumbsContainer > a").eq(count).offset();
              thumb_positionSelected = Math.round(thumb_selected.left - thumbs_containerPosition.left);
  
              cssContainerLeft = document.querySelector(".thumbsContainer").style.left;
              cssContainerLeftValue = cssContainerLeft.replace("px","");
              cssContainerLeftValue = Math.abs(cssContainerLeftValue);
                        
              $(".thumbsContainer").css("left","-"+(cssContainerLeftValue + thumb_positionSelected)+"px");
            }
        });
        
    
        $('.arrow__left').on('click', function() {
    
            // Mark current thumb
            var count = $("#thumbnailList .thumbsContainer > a.product-gallery__thumbnail.is-nav-selected").index();
            count--;
            if(count < 0){
                count = photos.length -1;
                $(".product-gallery__image").attr("srcset",photos[count]);
                $(".product-gallery__image").attr("data-zoom",photos[count]);
                $("#thumbnailList .thumbsContainer > a")[count].add
            }else{
                $(".product-gallery__image").attr("srcset",photos[count]);
                $(".product-gallery__image").attr("data-zoom",photos[count]);
            }
            
            $("#thumbnailList .thumbsContainer > a").removeClass("is-nav-selected")
            $("#thumbnailList .thumbsContainer > a").eq(count).addClass("is-nav-selected")

            if(thumbs_quant > 6){
                      
              // Advanced group of thumbnails
              thumb_selected = $("#thumbnailList .thumbsContainer > a").eq(count).offset();
              thumb_positionSelected = Math.round(thumb_selected.left - thumbs_containerPosition.left);
  
              cssContainerLeft = document.querySelector(".thumbsContainer").style.left;
              cssContainerLeftValue = cssContainerLeft.replace("px","");
              cssContainerLeftValue = Math.abs(cssContainerLeftValue);
                        
              $(".thumbsContainer").css("left","-"+(cssContainerLeftValue + thumb_positionSelected)+"px");
            }
        });
    
    // end: CODE TO IMAGE SLIDER ON PDP ------------------ //

    
    const resizeSelectors = [
      	'.quick-links-v2 h2',
      	'.footer-shoppers .fg span',
  		'.supp-mobil-sect .flex-mob-group .mob-body h2',
  		'.category-items-spons-group .spons__header h2',
      	'.sec_flex_group .sect__header h3'
    ];
    const slickInit = function() {
        const $slickCarousels = $('.slick-carousel');
      	
      	$slickCarousels.each(function() {
          	const $slickCarousel = $(this);
            const slickOptions = {
              rows: 1,
              slidesToScroll: 1,
              slidesToShow: 1,
              dots: false,
              arrows: false,
              infinite: true,
              customPaging: function(slider, i) {
                return '<span class="dot"></span>';
              },
              speed: 300,
              responsive: [{
                breakpoint: 1024,
                settings: { }
              }]
            };

            if(typeof $slickCarousel.attr('data-slidesToScroll') !== 'undefined') {
              const showSlideNum = parseInt($slickCarousel.attr('data-slidesToScroll') || 1);

              slickOptions.slidesToScroll = showSlideNum;
              slickOptions.slidesToShow = showSlideNum;
            }
          	if(typeof $slickCarousel.attr('data-rows') !== 'undefined') {
              slickOptions.rows = parseInt($slickCarousel.attr('data-rows'));
            }
            if(typeof $slickCarousel.attr('data-arrows') !== 'undefined') {
              slickOptions.arrows = $slickCarousel.attr('data-arrows') == "true";
            }
            if(typeof $slickCarousel.attr('data-speed') !== 'undefined') {
              slickOptions.speed = parseInt($slickCarousel.attr('data-speed'));
            }
            if(typeof $slickCarousel.attr('data-autoplay') !== 'undefined') {
              slickOptions.autoplay = $slickCarousel.attr('data-autoplay') == "true";
            }
          	if(typeof $slickCarousel.attr('data-swipe') !== 'undefined') {
              const canSwipe = $slickCarousel.attr('data-swipe') == "true";
              slickOptions.swipe = canSwipe;
            }
            if(typeof $slickCarousel.attr('data-responsive') !== 'undefined') {
              try {
              	slickOptions.responsive = JSON.parse($slickCarousel.attr('data-responsive'));
              } catch(e) {
                console.error('Err: Incorrect json formatting in data attribute for slick slider data-responsive');
              }
              /*
              console.log(
                'responsive',
                slickOptions.responsive,
                $slickCarousel.attr('class')
              );
              */
            }

            $slickCarousel.on('breakpoint init', function(event, slick) {
                let html = '<ul class="slick-dots custom-dots" style="display: block;">';
                const dotsLength = Math.ceil(slick.slideCount / slick.options.slidesToShow);
                const $dots = slick.$dots;
              	const IsSlideshow = $(slick.$slider).hasClass('slideshow');
              	
                if(dotsLength > 1)
                    html += '<li class="not-slick arrow-prev"><span></span></li>';
                for(var i = 0; i < dotsLength; i++) {
                    html += '<li ' + (i == 0 ? 'class="slick-active"' : '' ) + '><span class="dot"></span></li>';
                }
                if(dotsLength > 1)
                    html += '<li class="not-slick arrow-next"><span></span></li>';

                html += '</ul>';
              	
                if(dotsLength > 1)
                    $(slick.$list).append(html);
              
                if(IsSlideshow) {
                	matchHeights('.slideshow.slideshow--preserve-ratio .slideshow__content-wrapper', true, 50);
                }
            });

            $slickCarousel.on('swipe', function(event, slick, direction) {
                const currentSlide = slick.currentSlide;
                const $slickList = slick.$list.parents('.slick-slider');
              	//console.log('SWIPE: ', currentSlide);

                $slickList.find('.slick-active').removeClass('slick-active');
                $slickList.find('.slick-dots > li:not(.not-slick)').eq(currentSlide).addClass('slick-active');
            });

            $slickCarousel.slick(slickOptions);
          	
          	if($slickCarousel.hasClass('slick-collection-list')) {
          		window.matchHeights('#shopify-section-collection-list .collection-item__title');
          	}
      	});
    };
    
    deeplinkTo();
    slickInit();
    
    $(document).on('click', '.service-deeplink', function(e) {
      e.preventDefault();
      
      const target = $(this).attr('data-target');
      const section = $(this).attr('data-section');
      const $servicePageAttr = $(this).parents('.quick-links-v2').attr('data-service-page');
      const isServicePage = $servicePageAttr.length > 0 && $servicePageAttr == 'true';
      
      if(!isServicePage) {
          return window.location = "/pages/services?dl=" + section;
      }

      $('html, body').animate({ scrollTop: $(target).offset().top - 180}, 1000);
    });
    
    $(document).on('click', '.more-view-all', function(e) {
      e.preventDefault();
      const $this = $(this);
      const $moreGrid = $this.parent().find('.more-grid');
      const labelOptions = ["View All", "View Less"];
      const moreGridLength = $moreGrid.find('.more-grid-item:visible').length;
      
      if(moreGridLength > 6) {
          $moreGrid.find('.more-grid-item:gt(5)').slideUp(function() {
              $this.text(labelOptions[0]);
          }).addClass('.not-visible')
          return false;
      }

      $moreGrid.find('.not-visible').slideDown(function() {
          $this.text(labelOptions[1]);
      });
    });
    
    $(document).on('click', '.not-slick.arrow-next, .not-slick.arrow-prev', function() {
    	const $parentEl = $(this).parents('.custom-dots');
      	const numOfSlides = $parentEl.find('li:not(.not-slick)').length;
      	const $carousel = $(this).parents('.slick-slider');
      	var $goTo = [];
     	
        if($(this).hasClass('arrow-next')) {
          	$goTo = $carousel.find('.slick-active').next('li:not(.not-slick)');
          
          	if($goTo.length == 0)
              $goTo = $carousel.find('li:not(.not-slick)').eq(0);
        } else {
          	$goTo = $carousel.find('.slick-active').prev('li:not(.not-slick)');
          
          	if($goTo.length == 0)
              $goTo = $carousel.find('li:not(.not-slick)').eq($carousel.find('li:not(.not-slick)').length - 1);
        }
        $parentEl.find('li').removeClass('slick-active');
      	
      	//console.log('slick-item arrows', $goTo, numOfSlides);
      
      	if($goTo.length > 0)
        	$goTo.addClass('slick-active').trigger('click');
  	});
  
  	$(document).on('click', '.slick-dots.custom-dots > li', function() {
      if($(this).hasClass('not-slick')) return false;
      const $carousel = $(this).parents('.slick-slider');
      const numberOfColumns = $carousel.find('.slick-dots li:not(.not-slick)').length;
      let numberOfSlides = $carousel.slick('getSlick').$list.find('.slick-active').length;
      const IsSlideshow = $carousel.hasClass('slideshow');
      
      $carousel.find('.slick-dots.custom-dots > li').removeClass('slick-active');
      $(this).addClass('slick-active');
      
      const slideIndex = $(this).parents('.custom-dots').find('.slick-active').index() - 1;
      let slideActivePosition = !IsSlideshow ? slideIndex * numberOfSlides : slideIndex;
      
      if(!IsSlideshow) {
        numberOfSlides--;
        slideActivePosition = slideIndex * numberOfSlides;
      }
      //console.log('slick-item dots',IsSlideshow, numberOfColumns, numberOfSlides, slideIndex, slideActivePosition, $carousel);
      
      $carousel.slick('slickGoTo', slideActivePosition);
  	});
    
    $(document).on('click', '.category-banner .button', function() {
      var hash = $(this).attr('href');
      
      if(hash.indexOf('#deeplink=') > -1) {
      	deeplinkTo(hash, 1);
        return false;
      }
    });
   
    $(document).on('click', '.header__action-item--stay-touch, .stay-touch-nav > a, .popup-contact-us__close', function() {
      const $modalContactUsEl = $('#modal-contact-us');
      $modalContactUsEl.attr('aria-hidden', $modalContactUsEl.attr('aria-hidden') == 'false');
    });
    
    $(document).on('click', '.mega-menu__main_ul .mega-menu__title', function(e) {
      e.preventDefault();
      const $megaMenu = $('.mega-menu__inner');
      const href = $(this).attr('href');
      
      $megaMenu.find('.mega-menu__main_ul .active-menu').removeClass('active-menu');
      $(this).parents('li').addClass('active-menu');
      $megaMenu.find('.mm-col-sub .inner').css('visibility', 'visible');
      $megaMenu.find('.mega-menu__linklist').hide();
      $megaMenu.find('[data-parent-url="' + href + '"]').css('display', 'flex');
      
	  let learnMoreData = navLearnMore.filter(function(a) { if(a.id.toLowerCase().indexOf(href.toLowerCase()) > -1) return a; });
      if(learnMoreData != null && learnMoreData.length > 0) {
        learnMoreData = learnMoreData[0];
        const resourceLink = learnMoreData.cta_link;
		const resourceText = learnMoreData.cta_label + " Resources";
        
        $megaMenu.find('.mm-col-3 img').attr('src', learnMoreData.image_name);
        $megaMenu.find('.mm-col-3 p').text(learnMoreData.copy);
        $megaMenu.find('.mm-col-3 a').text(resourceText).attr('href', resourceLink);
        $('.shop_tablet_resource_link').attr('href', resourceLink).text(resourceText);
      }
    });
    
    //STAY IN THE KNOW FORM
    $(document).on('click', '.subscribe-submit-btn', function() {
      const $this = $(this);

      if($this.hasClass('disable-btn')) return false;
      $this.addClass('disable-btn');

      const $stayInTouchForm = $(this).parents('.stay-in-touch-form');
      const $email = $stayInTouchForm.find('.subscribe-email-input');
      const emailPattern = new RegExp(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/);
      const formData = {};
      const isEmailValid = emailPattern.test($email.val());

      if(isEmailValid) {
       	formData.email = $email.val().trim();
		$stayInTouchForm.removeClass('has-failed');
        
        $.ajax({
          url: "https://social.richmondday.com/contact.php",
          type: "POST",
          dataType: "json",
          data: formData,
          complete: function(data, status) {
            $this.removeClass('disable-btn');

            if(data.statusText == "error") 
              return console.error('Salesfource - Not Authorized - https://developer.salesforce.com/docs/atlas.en-us.mc-apis.meta/mc-apis/error-handling.htm');

            $stayInTouchForm.removeClass('has-failed');
            $stayInTouchForm.find('.hide-if-success').slideUp();
            $stayInTouchForm.find('.show-if-success').slideDown();
          }
        });
      } else {
        $this.removeClass('disable-btn');
        $stayInTouchForm.addClass('has-failed');
      }
    });
    
    $(document).on('click', '.nav-bar__linklist > .nav-bar__item:first-child > a', function(e) {
      const isValid = $(this).parents('.nav-bar__linklist').hasClass('nav-dropdown--glued');
      const pathName = window.location.pathname;
      const selector = '.mega-menu__main_ul .mega-menu__column > a[href="' + pathName + '"]';
      
      if(isValid) {
        const $menuItem = $(selector);
        
        if($menuItem.length > 0) {
        	$menuItem.trigger('click');
        } else {
      		$('.mega-menu__main_ul .mega-menu__column:first-child > a').trigger('click');
        }
      }
    });
    
    $(document).on('click', '.triple-nested-item .triple-nested-header', function(e) {
      e.preventDefault();
      const $parentEl = $(this).parents('.triple-nested-item');
      
      if($parentEl.hasClass('learn-nested')) {
        var attrButton = $parentEl.find('button').attr('aria-expanded');
        const href = $(this).parents('.mobile-triple-nested-nav').find('.mobile-menu__nav-link').attr('href');
        let learnMoreData = navLearnMore.filter(function(a) { if(a.id.toLowerCase().indexOf(href.toLowerCase()) > -1) return a; });
        let learnHtml = '';
        if(learnMoreData != null && learnMoreData.length > 0) {
          learnMoreData = learnMoreData[0];
          
          learnHtml = `
			<div class="content">
				<img src="${learnMoreData.image_name}" alt="" class="content_image">
				<p class="content_text">${learnMoreData.copy}</p>
				<a href="${learnMoreData.cta_link}" class="mobile-resource-link">${learnMoreData.cta_label + " Resources"}</a>
            </div>
			`;
        }
		$parentEl.find('.triple-nested-body').html(learnHtml);

        // Condition for accessibility of Learn accordion
        if(attrButton == "false"){
          $parentEl.find('button').attr('aria-expanded','true');
          $parentEl.find('.triple-nested-body').removeAttr('hidden');
        }else{
          $parentEl.find('button').attr('aria-expanded','false');
          $parentEl.find('.triple-nested-body').attr('hidden', '');
        }
        
      }
      
      $parentEl.toggleClass('is-active');
      $parentEl.find('.triple-nested-body').slideToggle();
    });
    
    $(document).on('click', '.mobile-open-triple-nested', function(e) {
      e.preventDefault();
      
      const target = $(this).attr('data-target');
      const $el = $(target);
      
      $el.addClass('is-open');
    });
    
    resizeSelectors.map(function(sel) {
      window.matchHeights(sel, true);
    });
    
    resizeSelectors.map(function(sel) {
      window.matchHeights(sel, true);
    });
    
    $('.no-blank').attr('target','_self');
  });
}(window, jQuery));

var productInfo = null;
var metafieldInfo = null;

const getProductInfo = () => {
  if(!productInfo) {
    var productJsonElement = document.querySelector('[data-product-json]');
    if (productJsonElement) {
      productInfo = JSON.parse(productJsonElement.innerHTML);
    }
  }

  return productInfo;
};

const getMetafieldInfo = () => {
  if(!metafieldInfo) {
    var productInfo  = getProductInfo();
    if (productInfo) {
      metafieldInfo = productInfo['metafields'];
    }
  }

  return metafieldInfo;
};

const calculateBasePco = (price) => {
  var priceStr = (price + '');
  var size = priceStr.length;
  var nonDecimalPrice = priceStr.substr(0, size-2);
  
  return nonDecimalPrice * 15;
  
};

const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const volumePricingToolTip = (lineSku,event) =>{  
  
          if(event === "mouseover"){
            
          	$("#v-price-"+lineSku+"").show();
            $("#volume_price_hover-"+lineSku+"").attr("aria-expanded","true");
          }
      
         if(event === "mouseout"){
          	$("#v-price-"+lineSku+"").hide();
            $("#volume_price_hover-"+lineSku+"").attr("aria-expanded","false");
          }
      
            if(event === "click"){
           
          	if ($("#v-price-"+lineSku+"").is(":visible")) {
          		$("#v-price-"+lineSku+"").hide();
              $("#volume_price_hover-"+lineSku+"").attr("aria-expanded","false");
          	} else {
          		$("#v-price-"+lineSku+"").show();
                $("#volume_price_hover-"+lineSku+"").attr("aria-expanded","true");
          	}
        }
      
    

}

const cancelOrder  = (cancelObj) => { 

    var answer = window.confirm("Are you sure you want to cancel the order?");
      
    if (answer) {     
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("shop", "wellwise-en.myshopify.com");  
    
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,			
            redirect: 'follow',
            body: JSON.stringify(cancelObj)
        };

      
        fetch("https://wellwise-prod-apim.azure-api.net/sci/ShopifyOrderCancel", requestOptions)
            .then(response => response.ok ? "" : response.text())      
            .then((result) => {
               console.log("result", result)
              
              if(result != ""){   
               $("#cancelMsg").append("<p class='alert alert--large alert--error'>"+result+"</p>")               
              }
              else{
                 $(".blockContent").show();
                 $(".blockContent").append("<span style='top: 50%;left: 50%;position: absolute;font-size: 35px;color:white; transform: translate(-50%, -50%);'>Order Cancellation in Progress...</span>")   
                
                  setTimeout(function() { 
                      $(".blockContent").hide();
                      window.location.reload();        
                   }, 2000)                 

              }
            })
            .catch(error => console.log(error));
    }
}


const printOrder = (order) => {     
    var mywindow = window.open('', 'PRINT', 'height=600,width=1000,target=self');
   
    var orderTransactions =  order.transactions.split(";");
    var basePoints = order.basePoints;
    var bonusPoints = order.bonusPoints;
    var totalPoints = order.totalPoints;

 mywindow.document.write('<html lang="en-ca"><head><title>' + document.title + '</title>'); 
    mywindow.document.write('<link rel="stylesheet" href="https://cdn.shopify.com/s/files/1/0547/5359/1469/t/628/assets/print-order.css" type="text/css" />');    
    mywindow.document.write('<style>@page { size: auto;  margin-top: 0mm; margin-bottom: 0mm }</style>');
    mywindow.document.write('</head><body >');
      mywindow.document.write('<main>');
          mywindow.document.write('<div class="container">');
              mywindow.document.write('<header>');
                  mywindow.document.write('<div class="lineOne">');
                      mywindow.document.write('<div class="colWellwise">');
                          mywindow.document.write('<h1>Wellwise.ca</h1>');  
                      mywindow.document.write('</div>');

                      mywindow.document.write('<ul class="dataList">');                          
                          mywindow.document.write('<li class="invoice">Official Receipt for: '+ order.orderNumber +'</li>');
                          mywindow.document.write('<li class="oderDate">Order Date: '+ order.orderDate +'</li>');
                      mywindow.document.write('</ul>');
                  mywindow.document.write('</div>');

                  mywindow.document.write('<div class="lineTwo">');
                      mywindow.document.write('<span class="line address">243 Consumers Road</span>');
                      mywindow.document.write('<span class="line city">Toronto ON M2J 4W8</span>');
                      mywindow.document.write('<span class="line country">Canada</span>');
                  mywindow.document.write('</div>');
              mywindow.document.write('</header>');

              mywindow.document.write('<section class="info itemDetails">');
                  mywindow.document.write('<h2 class="title">Item Details</h2>');
                  mywindow.document.write('<div class="contentTable">');
                      mywindow.document.write('<ul class="header">');
                          mywindow.document.write('<li class="col quantity">Quantity</li>');
                          mywindow.document.write('<li class="col items">Item</li>');
                          mywindow.document.write('<li class="col taxes">Taxes</li>');
                          mywindow.document.write('<li class="col price">Price</li>');
                      mywindow.document.write('</ul>');

                       for(var i=0;i < order.line_items.length; i++){
                         mywindow.document.write('<ul class="content">');
                            mywindow.document.write('<li class="col cQuantity">'+ order.line_items[i].quantity +'x</li>');
                            mywindow.document.write('<li class="col cItems"><h3 class="productName">'+ order.line_items[i].title +'</h3></li>');

                           if(order.line_items[i].tax_lines.length > 0){
                             mywindow.document.write('<li class="col cTaxes">'+ order.line_items[i].tax_lines[0].tax_line.price +' '+order.line_items[i].tax_lines[0].tax_line.title +'</li>');
                           }
                           else{
                               mywindow.document.write('<li class="col cTaxes">$0.00</li>');
                           }
                            mywindow.document.write('<li class="col cPrice">$'+ order.line_items[i].line_price+'</li>');
                        mywindow.document.write('</ul>');
                      }

                  mywindow.document.write('</div>');
              mywindow.document.write('</section>');

              mywindow.document.write('<section class="info transactionDetails">');
                  mywindow.document.write('<h2 class="title">Transaction Details</h2>');
                  mywindow.document.write('<div class="contentTable">');
                      mywindow.document.write('<ul class="header">');
                          mywindow.document.write('<li class="col type">Type</li>');
                          mywindow.document.write('<li class="col amount">Amount</li>');
                          mywindow.document.write('<li class="col kind">Kind</li>');
                          mywindow.document.write('<li class="col status">Status</li>');
                      mywindow.document.write('</ul>');

                      for (var index = 0; index < orderTransactions.length; index++) {
                            var itemsTransaction = orderTransactions[index].split(",");                        
                              if(itemsTransaction.length > 1){
                                  mywindow.document.write('<ul class="content">');
                                      mywindow.document.write('<li class="col cType">Credit Card</li>');
                                      mywindow.document.write('<li class="col cAmount">'+itemsTransaction[2] +'</li>');
                                      mywindow.document.write('<li class="col cKind">'+itemsTransaction[1]+'</li>');
                                      mywindow.document.write('<li class="col cStatus">'+itemsTransaction[0]+'</li>');
                                  mywindow.document.write('</ul>');
                              }
                        }
                
                  mywindow.document.write('</div>');
            mywindow.document.write('</section>');

            mywindow.document.write('<section class="info paymentDetails">');
                mywindow.document.write('<h2 class="title">Payment Details</h2>');
                mywindow.document.write('<div class="contentTable">');
                    mywindow.document.write('<ul class="line_subTotal">');
                        mywindow.document.write('<li class="col subTotal">Subtotal price:</li>');

                        if(order.subtotal_price == ""){
                          mywindow.document.write('<li class="col cSubTotal">$0.00</li>');
                        }else{
                          mywindow.document.write('<li class="col cSubTotal">'+ order.subtotal_price +'</li>');
                        }
                    mywindow.document.write('</ul>');

                    mywindow.document.write('<ul class="line_subTotalTax">');
                        mywindow.document.write('<li class="col subTotalTax">Total tax:</li>');

                        if(order.total_tax == ""){
                          mywindow.document.write('<li class="col cSubTotalTax">$0.00</li>');
                        }else{
                          mywindow.document.write('<li class="col cSubTotalTax">'+ order.total_tax +'</li>');
                        }
                    mywindow.document.write('</ul>');

                    mywindow.document.write('<ul class="line_shipping">');
                        mywindow.document.write('<li class="col shipping">Shipping:</li>');

                        if(order.shipping == ""){
                          mywindow.document.write('<li class="col cShipping">$0.00</li>');
                        }else{
                          mywindow.document.write('<li class="col cShipping">'+ order.shipping +'</li>');
                        }
                    mywindow.document.write('</ul>');

                    mywindow.document.write('<ul class="line_total">');
                        mywindow.document.write('<li class="col total">Total price:</li>');

                         if(order.total_price == ""){
                           mywindow.document.write('<li class="col cTotal">$0.00</li>');
                         }else{
                           mywindow.document.write('<li class="col cTotal">'+ order.total_price +'</li>');
                         }
                   mywindow.document.write('</ul>');
                mywindow.document.write('</div>');
            mywindow.document.write('</section>');

            mywindow.document.write('<section class="info shippingDetails">');
                mywindow.document.write('<h2 class="title">Shipping Details</h2>');
                mywindow.document.write('<div class="contentTable">');
                    mywindow.document.write('<ul class="line_shipping">');
                        mywindow.document.write('<li class="col shipping">');
                            mywindow.document.write('<h3 class="name">'+ order.shipping_address.name +'</h3>');
                            mywindow.document.write('<span class="address">'+ order.shipping_address.address1 +'</span>');
                            mywindow.document.write('<span class="city">'+ order.shipping_address.city +', '+ order.shipping_address.province +' '+ order.shipping_address.province_code +' '+ order.shipping_address.zip +'</span>');
                            mywindow.document.write('<span class="country">'+ order.shipping_address.country +'</span>');
                        mywindow.document.write('</li>');
                    mywindow.document.write('</ul>');
                mywindow.document.write('</div>');
            mywindow.document.write('</section>');

            mywindow.document.write('<section class="info billingDetails">');
                mywindow.document.write('<h2 class="title">Billing Details</h2>');
                mywindow.document.write('<div class="contentTable">');
                    mywindow.document.write('<ul class="line_billing">');
                        mywindow.document.write('<li class="col billing">');
                            mywindow.document.write('<h3 class="name">'+ order.billing_address.name +'</h3>');
                            mywindow.document.write('<span class="address">'+ order.billing_address.address1 +'</span>');
                            mywindow.document.write('<span class="city">'+ order.billing_address.city +', '+ order.billing_address.province +' '+ order.billing_address.province_code +' '+ order.billing_address.zip +'</span>');
                            mywindow.document.write('<span class="country">'+ order.billing_address.country +'</span>');
                        mywindow.document.write('</li>');
                    mywindow.document.write('</ul>');
                mywindow.document.write('</div>');
            mywindow.document.write('</section>');

        /* Wellwise asked to remove the PC Optimum for now
        if(order.guestUser != undefined && !order.guestUser){
  
            mywindow.document.write('<section class="info billingDetails">');
                  mywindow.document.write('<h2 class="title">PC Optimum Rewards</h2>');
                  mywindow.document.write('<div class="contentTable">');
                      mywindow.document.write('<ul class="line_billing">');
                          mywindow.document.write('<li class="col billing">');                            
                              mywindow.document.write('<div> <div style="display:inline-block; width: 65%; font-weight: 700"> Base Points:</div> <div style="display:inline-block"> '+ basePoints+' pts</div> </div>');
                              mywindow.document.write('<div> <div style="display:inline-block; width: 65%; font-weight: 700"> Bonus Points:</div> <div style="display:inline-block"> '+ bonusPoints+' pts</div> </div>');
                              mywindow.document.write('<div> <div style="display:inline-block; width: 65%; font-weight: 700"> Total Points:</div> <div style="display:inline-block"> '+ totalPoints+' pts</div> </div>');
                          mywindow.document.write('</li>');
                      mywindow.document.write('</ul>');
                  mywindow.document.write('</div>');
              mywindow.document.write('</section>');
          }*/
            mywindow.document.write('<div class="phrase">If you have any questions, please send an email to <a href="mailto:support@wellwise.ca" target="_blank" rel="noopener noreferrer">support@wellwise.ca</a></div>');
  
          mywindow.document.write('</div>');
      mywindow.document.write('</main>');
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/  

  //Check if its an Android device to no add the onafterprint function
  var ua = navigator.userAgent.toLowerCase();

   mywindow.onload = function() {
      mywindow.print();             
  };
  
  if(!(ua.indexOf("android") > -1)) {      
     mywindow.onafterprint = function () {
       mywindow.close();
    }
  }
 
}

//PCO
document.addEventListener('variant:changed', function(event) {
  
  var variant = event.detail.variant; // Gives you access to the whole variant details
    
  if(variant == null){
    return;
  }

  //Check if the variant is on sale
  if(variant.compare_at_price > variant.price){
    $("#sale-flag").show();
  }
  else{
    $("#sale-flag").hide();
  }
  
});


//Saving Rates
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details

  var savingsRateValue = document.querySelector('.savings-rate-container');

  if (!savingsRateValue) {
    return;
  }
  
  var onSale = variant && variant.compare_at_price > variant.price;

  var savePercentage =  onSale ? '<div class="savings-rate">' + Math.floor(((variant.compare_at_price - variant.price) * 100 ) / variant.compare_at_price) + '% Off</div>': '';
  
  savingsRateValue.innerHTML = savePercentage;
});

//Quantity Selector
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details

  var selectorMinusButton = document.getElementById('productQuantitySelectorMinus');
  var selector = document.getElementById('productQuantitySelector');
  var selectorPlusButton = document.getElementById('productQuantitySelectorPlus');
  
  var metafields = getMetafieldInfo();
  var metafieldVariant = variant? metafields.find(x => x.sku === variant.sku) : {};
  

  if (!selector || !selector || !selectorPlusButton ) {
    return;
  }
  
  if(variant && variant.available && metafieldVariant.availability == 'Online'){
   	selectorMinusButton.classList.remove("button--disabled");
    selectorPlusButton.classList.remove("button--disabled");
    selectorMinusButton.disabled = false;
    selector.disabled = false;
    selectorPlusButton.disabled = false;
  }
  else
  {
    selectorMinusButton.classList.add("button--disabled");
    selectorPlusButton.classList.add("button--disabled");
    selectorMinusButton.disabled = true;
    selector.disabled = true;
    selectorPlusButton.disabled = true;
    
  }
});

//Add to Cart Button
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details

  
  var currentButton = document.querySelector('.product-form__add-button');
  var productInfo = getProductInfo();
  if(!currentButton || !productInfo) {
  	return
  }
  
  if(!variant) {
    currentButton.insertAdjacentHTML('beforebegin', productInfo.findLocationButton);
    currentButton.remove();
  } else {
    var metafields = productInfo.metafields;
    var metafieldVariant = metafields.find(x => x.sku === variant.sku);

    if (!metafieldVariant) {
      return;
    }


    if(variant.available && metafieldVariant.availability == 'Online')
    {
      if(productInfo.templateSufix == 'pre-order') {
        currentButton.insertAdjacentHTML('beforebegin', productInfo.preOrderButton);
        currentButton.remove();
      } 
      else 
      {
        currentButton.insertAdjacentHTML('beforebegin', productInfo.addToCartButton);
        currentButton.remove();
      }
    } 
    else
    {
      currentButton.insertAdjacentHTML('beforebegin', productInfo.findLocationButton);
      currentButton.remove();
    }
  }
});

//Message below add to cart
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details

  
  var containter = document.querySelector('.div-abv-atc');
  var productInfo = getProductInfo();
  if(!containter || !productInfo) {
  	return
  }
  
  if(!variant) {
    containter.innerHTML = "";
  } else {
    var metafields = productInfo.metafields;
    var metafieldVariant = metafields.find(x => x.sku === variant.sku);

    if (!metafieldVariant) {
      return;
    }


    if(!variant.available && metafieldVariant.availability == 'Online')
    {
      containter.innerHTML = productInfo.outOfStockMessage + productInfo.remainderMessage;
    } 
    else if(metafieldVariant.availability == 'In Store')
    {
      containter.innerHTML = productInfo.inStoreOnlyMessage + productInfo.remainderMessage;
    }
    else 
    {
      containter.innerHTML = "";
    }
  }
});

window.addEventListener('load', () => {
  document.querySelectorAll('form-embed[id^=app-embed-container]')?.forEach(item => {
    item.shadowRoot.append(
      Object.assign(document.createElement('style'), {
        innerText : `
          [class*="_formPhoneInputContainer_"] img[class*="_flagIcon_py6yc_"]{
            height: 16px !important;
          }
        `
      })
    )
  });  
});
